import { EscalationsGroupInterface, InheritanceStatus } from "@swivl-mono/types";
import { Spinner } from "@swivl-mono/ui";
import React from "react";

import { InheritanceTag } from "../../../../Components/InheritanceTag/InheritanceTag";
import EscalationsModel from "../../../../Models/Escalations/Escalations.Model";
import "./EscalationGroupView.scss";

interface Props {
  group: EscalationsGroupInterface;
}

export function ParentEscalationGroupView(props: Props) {
  const { group } = props;
  const [isCustomizing, setIsCustomizing] = React.useState(false);
  const customizeClicked = async () => {
    setIsCustomizing(true);
    await EscalationsModel.makeGroupAChild(group);
  };
  return (
    <div className="EscalationGroup">
      <header>
        <InheritanceTag inheritance={InheritanceStatus.IS_PARENT} />

        <h3 className="text-lg font-semibold text-grey-800">{group.name}</h3>
        {isCustomizing ? (
          <Spinner />
        ) : (
          <div className="removeButton" onClick={customizeClicked}>
            CUSTOMIZE
          </div>
        )}
      </header>
    </div>
  );
}
